import { render, staticRenderFns } from "./comStep0.vue?vue&type=template&id=008ed94f&scoped=true&"
import script from "./comStep0.vue?vue&type=script&lang=js&"
export * from "./comStep0.vue?vue&type=script&lang=js&"
import style0 from "./comStep0.vue?vue&type=style&index=0&id=008ed94f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008ed94f",
  null
  
)

export default component.exports